// src/routes/banksRoutes.jsx
import React from "react";
import { Route } from "react-router-dom";
import ProtectedRoute from "../components/global/ProtectedRoute";

// Banks Components
import Banks from "../pages/Banks/Banks";
import CreateBank from "../pages/Banks/CreateBank";
import EditBank from "../pages/Banks/EditBank";

const banksRoutes = (
    <>
        <Route
            key="banks"
            path="banks"
            element={
                <ProtectedRoute requiredPermission="banks_list">
                    <Banks />
                </ProtectedRoute>
            }
        />
        <Route
            key="banks-archive"
            path="banks/archive"
            element={
                <ProtectedRoute requiredPermission="banks_archive_list">
                    <Banks />
                </ProtectedRoute>
            }
        />
        <Route
            key="banks-create"
            path="banks/create"
            element={
                <ProtectedRoute requiredPermission="banks_create">
                    <CreateBank />
                </ProtectedRoute>
            }
        />
        <Route
            key="banks-edit"
            path="banks/:id/edit"
            element={
                <ProtectedRoute requiredPermission="banks_edit">
                    <EditBank />
                </ProtectedRoute>
            }
        />
    </>
);

export default banksRoutes;
